import FormDataRouting from '~/mixins/form-data-routing'
import { scrollToStep } from '~/helpers/scroll'
import { sendToHubspot } from '~/helpers/hubspot'

export default

	mixins: [
		FormDataRouting
	]

	computed:

		allStepsValid: ->
			globalProgress = @$store.state.globals.progress || []
			for progress in Object.values globalProgress
				return false if progress < 1
			return true

	methods:

		onSubmit: ->

			# If this is the last step, then check if all previous steps are valid.
			throw 'INVALID_STEP' unless @allStepsValid

			if !@consentToProcess
				# If the user has not yet consented to process, then we are showing a consent message
				# above the 'Next' button, and let's now set consentToProcess to true.
				@$store.commit 'globals/setData',
					consentToProcess: true
					# We need to tell Hubspot the contents of the consent notice
					# we showed to the users.
					consentToProcessLabel: @consentToProcessMessage

			if @isFirstStep
				# This is the first step
				# Send form data to Hubspot
				# Only the first step will be filled out at this time
				await @sendToHubspot()

			if @step >= 1
				# This is step 2 or later
				# Throw error if we don't have at least one engineer
				throw 'NOT_ENOUGH_ENGINEERS' unless @results.engineersTotal > 0

			if @isLastStep
				# Send form data to Hubspot
				await @sendToHubspot()
				# Save form data to URL, and go to /results
				@writeFormDataToUrl('/results')

			# Increment the step number to show the next step, if necessary.
			@$store.commit('globals/nextStep') if @isActiveStep

			# Scroll to the next step.
			scrollToStep @currentStep

		sendToHubspot: -> sendToHubspot
			formData: @formData
			dataConfig: @dataConfig
			results: @results

